import React from 'react';
import { apiFetch } from '../../utils';

export class GoogleLogin extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Load the Google Platform Library
        const script = document.createElement('script');
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = this.initializeGoogle;
        document.body.appendChild(script);
    }

    initializeGoogle = () => {
        if (!window.google) {
            console.error("Google API not loaded");
            return;
        }

        window.google.accounts.id.initialize({
            client_id: '1052981490292-m42hjae4sapalhojbo83a67a63l19283.apps.googleusercontent.com',
            callback: this.handleCredentialResponse,
        });
    }

    handleCredentialResponse = (response) => {
        // response.credential contains the ID token
        this.handleGoogleLoginBackend(response.credential);
    }

    handleGoogleLoginBackend = (idToken) => {
        apiFetch('auth/google', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idToken }),
        })
            .then(res => res.json())
            .then(data => {
                if (data) {
                    this.props.onLoginSuccess?.(data);
                } else {
                    console.error('Backend login failed.');
                    alert(data?.message);
                }
            });
    }

    handleGoogleLogin = () => {
        if (!window.google) {
            alert("Google SDK not loaded yet.");
            return;
        }

        // Show the Google One Tap prompt
        window.google.accounts.id.prompt();
    }

    render() {
        return (
            <button onClick={this.handleGoogleLogin} className="btn btn-danger">
                Login with Google
            </button>
        );
    }
}
